var _path, _path2, _path3, _path4, _path5, _circle, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFidokeyDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 94,
    viewBox: "0 0 65 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.1868 25.9657C47.6345 25.9657 47.1868 25.518 47.1868 24.9657L47.1868 10.0486C47.1868 9.49632 47.6345 9.04861 48.1868 9.04861L57.5251 9.04861L57.5251 25.9657L48.1868 25.9657Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07447 28.7852C5.20848 28.7852 2.07446 25.6511 2.07446 21.7852L2.07446 7.22904C2.07446 6.67675 2.52218 6.22904 3.07446 6.22904L45.2469 6.22904C45.7991 6.22904 46.2469 6.67675 46.2469 7.22904L46.2469 27.7852C46.2469 28.3374 45.7992 28.7852 45.2469 28.7852L9.07447 28.7852Z",
    fill: "#266ACA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1347 29.725C4.71642 29.725 1.1347 26.1433 1.1347 21.725L1.1347 7.28918C1.1347 6.18461 2.03013 5.28918 3.1347 5.28918L45.1868 5.28918C46.2913 5.28918 47.1868 6.18461 47.1868 7.28918L47.1868 27.725C47.1868 28.8295 46.2913 29.725 45.1868 29.725L9.1347 29.725Z",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90638 21.5797C9.90638 22.2717 9.34534 22.8328 8.65326 22.8328C7.96119 22.8328 7.40015 22.2717 7.40015 21.5797C7.40015 20.8876 7.96119 20.3265 8.65326 20.3265C9.34534 20.3265 9.90638 20.8876 9.90638 21.5797Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0187 10.3018L55.0187 24.7126",
    stroke: "#2EA76D",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 33.5,
    r: 13.5,
    fill: "#D0021B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47.1633,
    y: 40.9032,
    width: 2.9299,
    height: 16.6028,
    rx: 1,
    transform: "rotate(-135 47.1633 40.9032)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45.0916,
    y: 29.1633,
    width: 2.9299,
    height: 16.6028,
    rx: 1,
    transform: "rotate(-45 45.0916 29.1633)",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFidokeyDelete);
export default __webpack_public_path__ + "static/media/fidokey-delete.8fcda824d121877b9ce8e27f31d0e3e8.svg";
export { ForwardRef as ReactComponent };